import {
  ShieldCheck,
  Award,
  Cpu,
  Clock,
  BadgeCheck,
  HeartHandshake,
} from "lucide-react";
import { WHY_US } from "@/data/site";

const ICONS = { ShieldCheck, Award, Cpu, Clock, BadgeCheck, HeartHandshake };

export default function WhyUs() {
  return (
    <section
      id="neden-biz"
      data-testid="why-us-section"
      className="relative py-24 lg:py-32 bg-[#050A1F] overflow-hidden"
    >
      <div className="absolute inset-0 bg-blueprint opacity-40 pointer-events-none" />
      <div className="absolute top-0 left-1/3 w-[500px] h-[500px] rounded-full bg-gold/8 blur-[120px] pointer-events-none" />

      <div className="relative max-w-7xl mx-auto px-4 sm:px-6 lg:px-8">
        <div className="mb-14 max-w-3xl">
          <p className="text-gold uppercase tracking-[0.4em] text-xs mb-3">
            Neden Star Otogaz?
          </p>
          <h2 className="font-display text-4xl sm:text-5xl lg:text-6xl font-bold leading-[1.05] text-balance">
            <span className="text-gradient-silver">
              Yıllardır Eskişehir'in
            </span>{" "}
            <span className="text-gradient-gold">tercih ettiği servis.</span>
          </h2>
        </div>

        <div className="grid grid-cols-1 sm:grid-cols-2 lg:grid-cols-3 gap-px bg-white/5 border border-white/5 rounded-2xl overflow-hidden">
          {WHY_US.map((w, i) => {
            const Icon = ICONS[w.icon] || ShieldCheck;
            return (
              <div
                key={w.title}
                data-testid={`why-us-item-${i}`}
                className="relative bg-[#050A1F] p-8 group hover:bg-[#0a1230] transition-colors"
              >
                <div className="flex items-start gap-5">
                  <div className="w-12 h-12 rounded-xl bg-gold/10 border border-gold/30 flex items-center justify-center flex-shrink-0 group-hover:bg-gold/20 group-hover:scale-110 transition-all duration-500">
                    <Icon className="w-5 h-5 text-gold" />
                  </div>
                  <div>
                    <h3 className="font-display font-semibold text-lg text-white mb-2">
                      {w.title}
                    </h3>
                    <p className="text-white/60 text-sm leading-relaxed">
                      {w.text}
                    </p>
                  </div>
                </div>
              </div>
            );
          })}
        </div>
      </div>
    </section>
  );
}
